/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_Published_FromInputs */

const cs_blog_filter_published_from = /** @type {(inputs: Blog_Filter_Published_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikováno od`)
};

const en_blog_filter_published_from = /** @type {(inputs: Blog_Filter_Published_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published from`)
};

/**
* | output |
* | --- |
* | "Published from" |
*
* @param {Blog_Filter_Published_FromInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_filter_published_from = /** @type {((inputs?: Blog_Filter_Published_FromInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_Published_FromInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_filter_published_from(inputs)
	return cs_blog_filter_published_from(inputs)
});